import { createAsyncAction, createStandardAction } from 'typesafe-actions'
import {
  PurchaseListReq,
  PurchaseListRes,
  CreatePurchaseReq,
  ActionPurchaseRes,
  UpdatePurchaseReq,
  DeletePurchaseReq,
  PurchaseDetailReq,
  PurchaseDetailRes,
  UpdatePurchaseStatusReq,
  LogsReq,
  LogsRes,
  CountReq,
  CountRes,
} from './types'

export const getPurchaseListAction = createAsyncAction(
  'PURCHASE/GET_PURCHASE_LIST_REQ',
  'PURCHASE/GET_PURCHASE_LIST_SUCCESS',
  'PURCHASE/GET_PURCHASE_LIST_FAILURE',
)<PurchaseListReq, PurchaseListRes, Error>()

export const getPurchaseDetailAction = createAsyncAction(
  'PURCHASE/GET_PURCHASE_DETAIL_REQ',
  'PURCHASE/GET_PURCHASE_DETAIL_SUCCESS',
  'PURCHASE/GET_PURCHASE_DETAIL_FAILURE',
)<PurchaseDetailReq, PurchaseDetailRes, Error>()

export const createPurchaseAction = createAsyncAction(
  'PURCHASE/CREATE_PURCHASE_REQ',
  'PURCHASE/CREATE_PURCHASE_SUCCESS',
  'PURCHASE/CREATE_PURCHASE_FAILURE',
)<CreatePurchaseReq, ActionPurchaseRes, Error>()

export const updatePurchaseAction = createAsyncAction(
  'PURCHASE/UPDATE_PURCHASE_REQ',
  'PURCHASE/UPDATE_PURCHASE_SUCCESS',
  'PURCHASE/UPDATE_PURCHASE_FAILURE',
)<UpdatePurchaseReq, ActionPurchaseRes, Error>()

export const deletePurchaseAction = createAsyncAction(
  'PURCHASE/DELETE_PURCHASE_REQ',
  'PURCHASE/DELETE_PURCHASE_SUCCESS',
  'PURCHASE/DELETE_PURCHASE_FAILURE',
)<DeletePurchaseReq, ActionPurchaseRes, Error>()

export const updatePurchaseStatusAction = createAsyncAction(
  'PURCHASE/UPDATE_PURCHASE_STATUS_REQ',
  'PURCHASE/UPDATE_PURCHASE_STATUS_SUCCESS',
  'PURCHASE/UPDATE_PURCHASE_STATUS_FAILURE',
)<UpdatePurchaseStatusReq, ActionPurchaseRes, Error>()

export const getLogsAction = createAsyncAction(
  'PURCHASE/GET_LOGS_REQ',
  'PURCHASE/GET_LOGS_SUCCESS',
  'PURCHASE/GET_LOGS_FAILURE',
)<LogsReq, LogsRes, Error>()

export const getCountAction = createAsyncAction(
  'PURCHASE/GET_COUNT_REQ',
  'PURCHASE/GET_COUNT_SUCCESS',
  'PURCHASE/GET_COUNT_FAILURE',
)<CountReq, CountRes, Error>()

export const clearEventAction = createStandardAction('PURCHASE/CLEAR_EVENT')<void>()
